<template>
  <div class="resident-card fade-in-fast">
    <router-link
      :to="{ name: 'Artist', params: { id: resident.permlink } }"
      class="resident-card__inner"
    >
      <picture class="resident-card__inner__image-container">
        <img
          v-if="resident"
          class="resident-card__inner__image"
          :src="$router.options.imagePath + resident.mediaUrl"
          :alt="resident.title"
        />
      </picture>
      <div class="resident-card__inner__location">
        {{ resident.locationModel.locationname }}
      </div>
      <div class="resident-card__inner__artist">
        {{ resident.name }}
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  props: {
    resident: {
      type: Object,
      required: true
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_resident-card.scss';
</style>
